import React from 'react';
import homeHero from '../../assets/home-hero.jpg';
import hyperlocalHero from '../../assets/hyperlocal-hero.jpg';
import engagementHub from '../../assets/engagement-hub.jpg';
import transparencyDashboard from '../../assets/transparency-dashboard.jpg';

const Visual = ({ src, alt, className }) => (
  <img src={src} alt={alt} className={className} loading="eager" decoding="async" />
);

export const HomeHeroVisual = () => (
  <Visual src={homeHero} alt="Governance platform overview" className="v3-visual-img v3-visual-hero" />
);

export const HyperlocalHeroVisual = () => (
  <Visual src={hyperlocalHero} alt="Hyperlocal platform dashboard" className="v3-visual-img v3-visual-wide" />
);

export const EngagementHubVisual = () => (
  <Visual src={engagementHub} alt="Leader engagement hub" className="v3-visual-img v3-visual-card" />
);

export const TransparencyDashboardVisual = () => (
  <Visual
    src={transparencyDashboard}
    alt="AI transparency dashboard"
    className="v3-visual-img v3-visual-card"
  />
);

export const TeamAvatarVisual = ({ name }) => {
  const initial = (name || '?').charAt(0).toUpperCase();
  return (
    <div className="v3-visual-img v3-visual-avatar v3-avatar-fallback" aria-label={`${name} avatar`}>
      {initial}
    </div>
  );
};
